<div class="card card-class">
    <h5 class="card-title"><mat-icon>menu_book</mat-icon>Question Bank</h5>
      <div class="card-body card-details">
          <button class="btn add-new-user" (click)="openDialogQuestion()"><i class="fas fa-plus"></i>ADD QUESTION</button> 
          <!--<button class="btn add-new-user" (click)="downloadQuestions()"><i class="fas fa-download"></i>DOWNLOAD QUESTIONS</button> 
          <button class="btn add-new-user" (click)="downloadAnswers()"><i class="fas fa-download"></i>DOWNLOAD ANSWERS</button>--> 
      <div class="content" fxLayout="row wrap" fxLayoutGap="16px grid">
        <div fxFlex="20%" *ngFor="let question of questionData">
          <mat-card class="mat-elevation-z4" >
            <mat-card-content>
                <mat-icon class="center-icon">menu_book</mat-icon>
              <p>
                {{question.questionText }}
              </p>
            </mat-card-content>
            <mat-card-actions>
              <mat-icon (click)="editQuestion(question)">edit</mat-icon>
              <mat-icon (click)="deleteQuestion(question)">delete</mat-icon>
            </mat-card-actions>
          </mat-card>
        </div>
      </div>
    </div>
</div>

